"use client";

import { useEffect } from "react";

/** On mount, smoothly scrolls the element with the given id to the top of the viewport (below the sticky header). */
export function ScrollIntoFocus({ targetId }: { targetId: string }) {
  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const t = setTimeout(() => el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }), 150);
    return () => clearTimeout(t);
  }, [targetId]);
  return null;
}
